import { publicPaths } from './paths/publicPaths';
import SetupPasswordPage from '@/features/admin-users/pages/SetupPasswordPage';
import LoginPage from '@/features/auth/pages/LoginPage';
import NewPasswordPage from '@/features/auth/pages/NewPasswordPage';
import ResetPasswordPage from '@/features/auth/pages/ResetPasswordPage';
import UnauthorizedPage from '@/features/auth/pages/UnauthorizedPage';

export interface PublicRoute {
  path: string;
  component: React.ReactNode;
}

const PublicRoutes: PublicRoute[] = [
  {
    path: publicPaths.LOGIN,
    component: <LoginPage />,
  },
  {
    path: publicPaths.FORGOT_PASSWORD,
    component: <ResetPasswordPage />,
  },
  {
    path: publicPaths.NEW_PASSWORD,
    component: <NewPasswordPage />,
  },
  {
    path: publicPaths.SETUP_PASSWORD,
    component: <SetupPasswordPage />,
  },
  {
    path: publicPaths.UNAUTHORIZED,
    component: <UnauthorizedPage />,
  },
];

export default PublicRoutes;
